import styled from "styled-components";

export const TitleText = styled.p`
  background-image: linear-gradient(#fff, #171717);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-size: 75px;
  font-weight: 800;

  @media (max-width: 773px) {
    font-size: 28px;
    font-weight: 600;
  }
`;